{
	"activity": {
		"call_title": "The call",
		"counters": {
			"acknowledged": "Seen",
			"awaiting_review": "To see",
			"awaiting_student_number": "Waiting for the student number",
			"direct": "Received by direct PEC",
			"open_flags": "Flags to close",
			"pending_verifications": "Verifications waiting",
			"superseded": "Replaced",
			"title": "Applications",
			"valid": "Valid",
			"with_problem": "With a problem",
			"withdrawn": "Withdrawn"
		},
		"dates_not_set": "Dates to be set",
		"nav": {
			"activity": "Activity",
			"applications": "Applications",
			"arrivals": "Arrivals",
			"call": "Call",
			"flags": "Flags",
			"flags_open_one": "{{count}} flag to close",
			"flags_open_other": "{{count}} flags to close",
			"label": "Pages of the residence",
			"offers": "Offers",
			"ranking": "Ranking",
			"verifications_pending_one": "{{count}} verification to complete",
			"verifications_pending_other": "{{count}} verifications to complete"
		},
		"news": {
			"mark_seen": "Mark as seen",
			"mark_seen_for": "Mark the application with protocol {{protocol}} as seen",
			"replacement": "The application with protocol {{protocol}} was replaced by a new application",
			"restored": "The application with protocol {{protocol}} is valid again",
			"title": "News",
			"withdrawal": "The application with protocol {{protocol}} was withdrawn by the student"
		},
		"page_title": "Activity",
		"period": "From {{start}} to {{close}}",
		"tasks": {
			"approve_ranking": "Check and approve the ranking",
			"confirm_data": "Confirm the residence data",
			"confirm_mailbox_test": "Read the test email in the PEC of the call and confirm the code",
			"confirm_offer_expiries_one": "Confirm {{count}} lapse of an offer with no answer, or record the answer that arrived in time",
			"confirm_offer_expiries_other": "Confirm {{count}} lapses of offers with no answer, or record the answers that arrived in time",
			"dsu_quota_below_threshold_one": "The DSU quota is below threshold: {{count}} seat at the DSU rate missing",
			"dsu_quota_below_threshold_other": "The DSU quota is below threshold: {{count}} seats at the DSU rate missing",
			"due": "By {{date}}",
			"due_end_of_day": "By {{date}} at 24:00",
			"empty": "No pending task",
			"open": "Open",
			"read_notices_one": "Look at {{count}} change to the applications",
			"read_notices_other": "Look at {{count}} changes to the applications",
			"resend_bounced_offers_one": "Send again {{count}} offer that did not reach the student",
			"resend_bounced_offers_other": "Send again {{count}} offers that did not reach the students",
			"resolve_flags_one": "Close {{count}} requirement flag",
			"resolve_flags_other": "Close {{count}} requirement flags",
			"review_applications_one": "Read {{count}} application that reached the PEC and confirm it is valid",
			"review_applications_other": "Read {{count}} applications that reached the PEC and confirm they are valid",
			"send_offers_by_pec_one": "Send {{count}} offer from the PEC of the residence and record the time of the receipt",
			"send_offers_by_pec_other": "Send {{count}} offers from the PEC of the residence and record the time of the receipts",
			"title": "Pending tasks",
			"upload_direct_applications": "Check the PEC of the residence and load the direct applications",
			"verifications_pending_one": "Verify the documents of {{count}} assignee who accepted",
			"verifications_pending_other": "Verify the documents of {{count}} assignees who accepted"
		}
	},
	"applications": {
		"phase": {
			"full": "No seat free: applications open again by themselves when a seat frees up.",
			"remaining": "Open: students apply while a seat is free.",
			"stopped": "Stopped on {{when}}."
		},
		"resume": "Open the applications again",
		"resumed": "Applications open again.",
		"stop": "Stop the applications",
		"stopped": "Applications stopped.",
		"title": "Applications on the seats left"
	},
	"calls": {
		"empty": "You have not created a call yet. Create one with \"New call\" on one of your residences.",
		"new": {
			"button": "New call",
			"choose": "Pick a residence",
			"create": "Create the call",
			"description": "Pick the residence and when applications open and close.",
			"none": "All your residences already have a call.",
			"residence": "Residence",
			"title": "New call"
		},
		"page_title": "Calls"
	},
	"corrections": {
		"contract_save": "Save the contract data",
		"contract_saved": "Contract data corrected on the call: the next offers carry it as it is.",
		"funded_beds": {
			"note": "It does not change the published call: it feeds the DSU quota, which covers at least 30% of it.",
			"save": "Save the beds admitted to funding",
			"saved": "Beds admitted to funding corrected on the call.",
			"title": "Beds admitted to funding"
		},
		"intro": "A published call keeps the copy of the data it went out with. Here you correct the contract data and, for the general admin, the beds admitted to funding: the correction applies to this call and does not change the residence, which the next call is made from.",
		"title": "Call corrections"
	},
	"data": {
		"call_link": "Call on the website",
		"cap": "Quota 70% cap",
		"deposit": "Deposit",
		"double_rate": "{{rate}} double",
		"dsu_rate": "DSU rate",
		"equipped": "Equipped rooms",
		"funded": "Funded places",
		"holder": "Account holder",
		"institutions": "Universities",
		"no_rate": "rate to enter",
		"operator": "Operator",
		"pec": "Certified email",
		"quota_double_one": "{{count}} seat in a double room, {{rate}}",
		"quota_double_other": "{{count}} seats in double rooms, {{rate}}",
		"quota_single_one": "{{count}} seat in a single room, {{rate}}",
		"quota_single_other": "{{count}} seats in single rooms, {{rate}}",
		"rate_month": "{{rate}} a month",
		"required_missing": "Missing: needed to publish",
		"services": "Services",
		"signing": "Signing",
		"signing_days_one": "Within {{count}} day of acceptance",
		"signing_days_other": "Within {{count}} days of acceptance",
		"single_rate": "{{rate}} single",
		"site_address": "Address",
		"site_bathrooms": "Bathrooms",
		"site_equipped": "Equipped seats",
		"site_kitchens": "Kitchens",
		"site_seats": "Seats",
		"site_seats_value": "{{single}} in single rooms, {{double}} in double rooms",
		"site_services": "Other services",
		"site_title": "Site {{number}}: {{name}}",
		"site_typology": "Typology",
		"tab_contract": "Contract and payments",
		"tab_privacy": "DPO and address for information",
		"tab_residence": "Residence and services",
		"tab_seats": "Seats and rates",
		"tab_sites": "Sites",
		"total": "Seats in total"
	},
	"dates": {
		"change_until_open": "You can change them until applications open.",
		"close": "Close",
		"close_time": "Applications close at {{time}} of the end day, Italian time.",
		"closes_on": "Applications close on {{day}} at {{time}}, Italian time.",
		"edit": "Change dates",
		"end_day": "End day",
		"errors": {
			"end_before_start": "The call would close before it opens: choose a later end day.",
			"invalid": "That time does not exist because of the daylight saving change: choose another time.",
			"locked": "The call is open: its dates can no longer change.",
			"missing": "Fill in start day, start time and end day.",
			"start_in_past": "The start has already passed: choose a future date."
		},
		"save": "Save the dates",
		"saved": "Dates saved.",
		"start": "Start",
		"start_day": "Start day",
		"start_time": "Start time",
		"title": "Call dates",
		"until": "until"
	},
	"document": {
		"download": "Download the call (PDF)"
	},
	"figures": {
		"closes": "closes {{when}}",
		"opens": "opens {{when}}",
		"period": "Period",
		"q30": "Quota 30%",
		"q70": "Quota 70%"
	},
	"mailbox_test": {
		"code": "Code of the test email",
		"code_format": "The code has 6 digits.",
		"confirmed": "Mailbox verified on {{date}}.",
		"help": "The applications reach the PEC of the call as ordinary emails. If the test email does not arrive, check with your provider that the mailbox accepts messages from non-PEC addresses.",
		"no_address": "The PEC address of the call is missing: enter it with \"Edit the data\".",
		"none": "You have not sent the test email to {{address}} yet. The applications reach that address as ordinary emails: the test checks that the mailbox takes them.",
		"refused": "The mailbox refused the email: check that it accepts ordinary mail, then send another.",
		"send": "Send the test email",
		"send_again": "Send again",
		"sent": "Test email sent. Look for it in the PEC of the call.",
		"submit": "Confirm the code",
		"title": "Test of the PEC of the call",
		"voided": "Wrong code five times: the test is void. Send the test email again.",
		"waiting": "The test email went to {{address}}. Open it in the PEC and enter the code here.",
		"wrong_code_one": "Wrong code. Attempts left: {{count}}",
		"wrong_code_other": "Wrong code. Attempts left: {{count}}"
	},
	"preview": {
		"open": "Preview of the residence page"
	},
	"previous_year": {
		"go": "Go to the {{year}} call to stop the applications",
		"go_offers": "Go to the {{year}} call to end the offers",
		"reason": "The {{previous}} call still takes applications on the seats left. Stop the applications to publish the {{year}} call.",
		"reason_offers": "The {{previous}} call still has offers waiting for an answer or a calculation to work. End the offers to publish the {{year}} call."
	},
	"proof": {
		"label": "Proof",
		"too_large": "The file is larger than 25 MB.",
		"upload_failed": "The file could not be uploaded. Try again.",
		"uploading": "Uploading"
	},
	"publish": {
		"blockers": {
			"end_before_start": "The close comes before the start.",
			"start_in_past": "The start has already passed: choose a future date."
		},
		"button": "Publish",
		"closed_title": "Applications closed",
		"confirm_button": "Publish the call",
		"confirm_data": "I checked the residence data.",
		"confirm_data_blocked": "First complete and fix the residence data.",
		"confirm_data_voided": "The data changed on {{date}}: check it again and confirm.",
		"confirm_description": "The dates must match the official call published on the residence's website. After publication rules and data no longer change; dates can change until the call opens.",
		"confirm_title": "Publish the call?",
		"copy_ranking_url": "Copy the ranking address",
		"open_title": "Applications open",
		"published": "Call published.",
		"published_at": "Published on",
		"published_title": "Call published",
		"ranking_url": "Public ranking",
		"ranking_url_copied": "Address copied."
	},
	"residence": {
		"data_complete": "Residence data complete",
		"edit": "Edit the data",
		"empty": "Not given",
		"go_to_call": "Go to the call",
		"next_call_note": "Changes apply to the next call: the {{year}} call stays as it is. The contract data of that call are corrected on its page.",
		"page_intro": "You can save halfway through.",
		"quota70": {
			"error": "We could not load the 70% quota list. Try again.",
			"open_ranking": "Open the ranking",
			"waits": "The list shows once the ranking is calculated, after the call closes."
		},
		"saved": "Residence data saved. Remember to confirm it again before publishing.",
		"saved_next_call": "Residence data saved: they apply to the next call.",
		"tabs": {
			"quota70": "70% quota"
		},
		"title": "Residence data"
	},
	"residences": {
		"applications": "Applications",
		"dates_not_set": "Dates to set",
		"empty": "You have no residences yet: the general admin assigns you one by email.",
		"next": {
			"closed": "Closed: nothing to do for now",
			"confirm_data": "Confirm the residence data",
			"data_invalid": "Some residence data does not add up: fix it in the residence data",
			"mailbox_test": "Send the test email to the PEC of the call",
			"open": "Applications open: it closes on its own",
			"privacy_contacts": "The DPO or the address for information is missing: fill it in the residence data",
			"published": "Published: it opens on its own at the start",
			"rate_references": "DSU rate and cap missing: enter them in the residence data",
			"ready": "Ready to publish",
			"set_dates": "Set the dates of the call",
			"sites": "Site details missing: fill them in the residence data"
		},
		"notices_one": "{{count}} news on the applications",
		"notices_other": "{{count}} news on the applications",
		"period": "Call period:"
	},
	"status": {
		"draft_one": "{{count}} step left before publishing",
		"draft_other": "{{count}} steps left before publishing",
		"ready": "Ready to publish"
	},
	"steps": {
		"data_check": "The data below goes into the call: check it, correct it if needed, then confirm.",
		"data_missing": "Some data is missing or does not add up: complete it with \"Edit the data\".",
		"data_title": "Check the data",
		"dates_hint": "Choose when applications open and the day they close."
	},
	"structures": {
		"call": "Call",
		"data_complete": "Data complete",
		"data_missing": "To complete: {{items}}",
		"intro": "Complete the data of each residence: the call is written from it. Then create the call from \"Calls\".",
		"missing": {
			"data_invalid": "data that does not add up",
			"privacy_contacts": "DPO or address for information",
			"rate_references": "reference rates",
			"sites": "sites"
		},
		"no_call": "No call yet",
		"no_city": "Site still to add",
		"page_title": "Residences"
	},
	"years": {
		"label": "Academic year",
		"option": "Academic year {{year}}",
		"read_only": "The {{year}} call is read only: you can see everything, nothing can be changed.",
		"read_only_short": "Read only"
	}
}
